import { render, staticRenderFns } from "./stay-in-touch.vue?vue&type=template&id=27f7b7ee&scoped=true&"
import script from "./stay-in-touch.vue?vue&type=script&lang=js&"
export * from "./stay-in-touch.vue?vue&type=script&lang=js&"
import style0 from "./stay-in-touch.vue?vue&type=style&index=0&id=27f7b7ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7b7ee",
  null
  
)

export default component.exports